var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('tax-group-form',{attrs:{"loading":_vm.loading,"taxGroupData":_vm.taxGroup,"formErrors":_vm.formErrors},on:{"taxGroupSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }